// ===========================================
// components/BookGrid.js
// ===========================================
import React from 'react';
import BookCard from './BookCard';

const BookGrid = ({ books, onViewBook, onDownloadBook, isLoading = false }) => {
  return (
    <div className="space-y-6">
      {/* Books Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
        {books.map((book, index) => (
          <div
            key={book.id}
            className="animate-fade-in"
            style={{ 
              animationDelay: `${(index % 20) * 50}ms`,
              animationFillMode: 'both'
            }}
          >
            <BookCard
              book={book}
              onView={onViewBook}
              onDownload={onDownloadBook}
            />
          </div>
        ))}
      </div>

      {/* Loading skeleton for new books */}
      {isLoading && (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6">
          {Array.from({ length: 10 }).map((_, index) => (
            <div key={`skeleton-${index}`} className="bg-white rounded-xl shadow-md overflow-hidden">
              <div className="h-48 bg-gray-200 animate-pulse"></div>
              <div className="p-4 space-y-2">
                <div className="h-4 bg-gray-200 rounded animate-pulse"></div>
                <div className="h-3 bg-gray-200 rounded animate-pulse w-3/4"></div>
                <div className="h-2 bg-gray-200 rounded animate-pulse w-1/2"></div>
                <div className="flex gap-2 mt-3">
                  <div className="flex-1 h-8 bg-gray-200 rounded animate-pulse"></div>
                  <div className="flex-1 h-8 bg-gray-200 rounded animate-pulse"></div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default BookGrid;